/**
* @file Oblique, The front-end framework for your Swiss branded UI.
* @copyright 2020 - 2026 Federal Office of Information Technology, Systems and Telecommunication FOITT {@link https://www.bit.admin.ch}
* @version 15.1.3 (released on 2026-03-25, supported at least until 2027-02-28)
* @author Oblique team, FOITT, BS-BSC-EN4 <oblique@bit.admin.ch>
* @license MIT {@link https://github.com/oblique-bit/oblique/blob/master/LICENSE}
* @see https://oblique.bit.admin.ch
*/

(()=>{try{return!(window.localStorage&&CSS.supports("display: flex")&&CSS.supports("display: grid")&&CSS.supports("height","100dvh")&&"".startsWith&&[].includes&&Object.values&&document.querySelectorAll("c").forEach)}catch(t){return 1}})()&&document.querySelector(".ob-compatibility").removeAttribute("hidden");